export default __webpack_public_path__ + "static/media/logo.d7605112.png";